export const typesOfComments = {
    firstComment: "firstComment",
    notFirstComment: "notFirstComment",
    replyToComment: "replyToComment",
    replyToReply: "replyToReply"
} as const

export const commentStatus = {
    published:"published",
    heldForReview:"heldForReview"
} as const

export const alphabetColors: any = {
    A: "#FF5733", // red-orange
    B: "#33A1FF", // sky blue
    C: "#28B463", // emerald green
    D: "#AF7AC5", // lavender
    E: "#F4D03F", // yellow
    F: "#DC7633", // burnt orange
    G: "#3498DB", // blue
    H: "#E74C3C", // red
    I: "#1ABC9C", // turquoise
    J: "#F39C12", // amber
    K: "#8E44AD", // purple
    L: "#45B39D", // teal
    M: "#E67E22", // orange
    N: "#2ECC71", // green
    O: "#5D6D7E", // gray-blue
    P: "#D35400", // dark orange
    Q: "#2E86C1", // steel blue
    R: "#C0392B", // brick red
    S: "#27AE60", // jade
    T: "#F1C40F", // golden
    U: "#7D3C98", // deep violet
    V: "#16A085", // greenish cyan
    W: "#F1948A", // soft pink
    X: "#566573", // blue-gray
    Y: "#D4AC0D", // mustard
    Z: "#154360", // navy

    // Numbers 0–9
    0: "#7DCEA0", // light green
    1: "#F7DC6F", // lemon
    2: "#BB8FCE", // light purple
    3: "#F5B7B1", // soft red
    4: "#76D7C4", // mint
    5: "#F8C471", // peach
    6: "#85929E", // muted blue
    7: "#F1948A", // pink
    8: "#82E0AA", // spring green
    9: "#AAB7B8", // gray
};
